module.exports = __webpack_public_path__ + "img/tn-stock-6.efffb544.jpeg";